// src/pages/SplashPage.jsx - Modification à ajouter
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoImage from '../assets/logo.png';
import '../styles/splash.css';

const SplashPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    // Définir un délai minimum pour l'animation du splash
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 5000); // 2 secondes pour l'animation

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Rediriger une fois que l'animation est terminée et que le statut d'auth est connu
    if (animationComplete && !loading) {
      if (isAuthenticated) {
        // Si connecté, aller vers la page prototype
		navigate('/welcome-page');
      } else {
        // Si non connecté, aller vers la page d'inscription/connexion
        navigate('/register');
      }
    }
  }, [animationComplete, isAuthenticated, loading, navigate]);

  return (
    <div className="splash-container">
      <div className="splash-background">
        <div className="splash-overlay">
          <div className="splash-content">
            <img 
              src={logoImage} 
              alt="Boissons du Cameroun" 
              className="splash-logo animate-fade-in"
            />
            
            <p className="splash-subtitle animate-slide-up-delay">
              Commandez et faites vous livrer à domicile
            </p>
            <div className="splash-loader animate-fade-in-delay">
              <div className="loader-spinner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;